import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Avatar as MUIAvatar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HTMLAttributes } from "react";

import { AssetUrl, assetUrlToVaultUrl, VaultUrl } from "@holibob-packages/vault";

export const AvatarSizes = {
    small: 32,
    medium: 48,
    large: 128,
} as const;
export type AvatarSize = keyof typeof AvatarSizes;

const MAX_SIZE = Math.max(...Object.values(AvatarSizes));

export type AvatarProps = {
    src?: string | AssetUrl;
    size?: AvatarSize;
    name: string;
} & Omit<HTMLAttributes<HTMLDivElement>, "children">;

function getAvatarUrl(src: NonNullable<AvatarProps["src"]>) {
    if (src instanceof AssetUrl) {
        const url = assetUrlToVaultUrl(src);
        if (url instanceof VaultUrl) {
            return url
                .modifyEdits({
                    resize: {
                        fit: "cover",
                        width: MAX_SIZE * 2,
                        height: MAX_SIZE * 2,
                    },
                })
                .toString();
        }
        return url.toString();
    }
    return src;
}

const Wrapper = styled(MUIAvatar)({
    ...Object.fromEntries(
        Object.entries(AvatarSizes).map(([name, size]) => {
            return [`&[data-size="${name}"]`, { width: size, height: size }];
        })
    ),
});

export function Avatar({ src, size = "small", name, ...props }: AvatarProps) {
    return (
        <Wrapper data-size={size} {...props} src={src ? getAvatarUrl(src) : undefined} alt={name}>
            {!src && <AccountCircleIcon fontSize={size} />}
        </Wrapper>
    );
}
